import { Grid2, IconButton, Typography } from "@mui/material";
import { formatInTimeZone } from "date-fns-tz";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useMeasure from "react-use-measure";
import BannerIco from "../../assets/icons/BannerIco";
import HarizonAddCandidateIco from "../../assets/icons/HarizonAddCandidateIco";
import HarizonGenerateSowIco from "../../assets/icons/HarizonGenerateSowIco";
import HarizonHelpCenter from "../../assets/icons/HarizonHelpCenter";
import HarizonNewJobIco from "../../assets/icons/HarizonNewJobIco";
import HarizonQuickMatchIco from "../../assets/icons/HarizonQuickMatchIco";
import HarizonUserManualIco from "../../assets/icons/HarizonUserManualIco";
import XCloseIco from "../../assets/icons/XCloseIco";
import SnackBar from "../../component/SnackBar";
import { NotificationBanner, UserName } from "../../redux/action/Harizon";
import { MinimizeIcon } from "../../redux/action/Login";
import { HandleSkeletion } from "../../utils/constants";
import { CustomDiv } from "../chat-bot/style";
import { CommonGrid2 } from "../common-components/StyledComponents";
import { CustomizeSpan } from "../jobs/style";
import QuickLink from "./components/QuickLink";
import QuickView from "./components/QuickView";

const Dashboard = () => {
  const [ref, bounds] = useMeasure();
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [banner, setBanner] = useState(true);
  const [searchHarizon, setSearchHarizon] = useState({
    search: "",
    helpAccord: true,
  });
  const [data, setData] = useState({
    greeting: "",
    quickLink: "",
  });
  const [quickViewValue, setQuickViewValue] = useState(0);
  const [chatBotData, setChatBotData] = useState({
    message: [],
    value: "",
    loader: false,
    pageLoader: false,
    details: "See Details",
  });
  const gridRef = useRef();
  const quickLinkData = [
    {
      icon: <HarizonQuickMatchIco />,
      title: "Quick Match",
      description: "Upload the Job Description and Resumes to find out if they are a match.",
      navigate: "/tools/quick-match",
    },
    {
      icon: <HarizonNewJobIco />,
      title: "Create a New Job",
      description: "Create a new job Using the available methods.",
      navigate: "/create-new-job",
    },
    {
      icon: <HarizonAddCandidateIco />,
      title: "Add Candidates",
      description: "Add New Candidates to your database using available methods.",
      navigate: "/resume-intelligence/create-candidate-resume",
    },

    {
      icon: <HarizonGenerateSowIco />,
      title: "Generate SOW",
      description:
        "Generate a SOW Document using any of the available methods.",
      navigate: "/sow-enrichment",
    },
  ];
  const [filteredQuickLink, setFilteredQuickLink] = useState(quickLinkData);

  const handleChatClick = () => {
    dispatch(MinimizeIcon(true, true));
    console.log("sfnsflknsnfslkfkk");
  };

  const helpData = [
    {
      icon: <HarizonUserManualIco />,
      title: "User Manual",
      description: "Tutorials on how to use Titan Data efficiently",
      navigate: "/home/user-manual",
    },
    {
      icon: <HarizonHelpCenter />,
      title: "Support",
      description: "Chat with Hailey to ask for support",
      onClick: handleChatClick,
      // navigate: "/resume-intelligence/create-candidate-resume",
    },
  ];
  const [helpFiltered, setHelpFiltered] = useState(helpData);

  const getGreeting = (timeZone) => {
    const hour = Number(formatInTimeZone(new Date(), timeZone, "H"));

    if (hour >= 5 && hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    return "Good Evening";
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const notification = await NotificationBanner();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const userName = await UserName(storageData?.user_id);
      setData((prev) => ({
        ...prev,
        quickLink: userName,
        greeting: getGreeting(userTimeZone),
        notification: notification?.data?.notification,
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleQuickLinkNavigate = (link) => {
    navigate(link);
  };

  const handleSearchQuickLink = (e) => {
    const value = e.target.value;
    setSearchHarizon({ search: value, helpAccord: true });

    const filtered = quickLinkData.filter(
      (item) =>
        item.title.toLowerCase().includes(value.toLowerCase()) ||
        item.description.toLowerCase().includes(value.toLowerCase())
    );

    const helpFilteredData = helpData.filter(
      (item) =>
        item.title.toLowerCase().includes(value.toLowerCase()) ||
        item.description.toLowerCase().includes(value.toLowerCase())
    );

    setHelpFiltered(helpFilteredData);

    setFilteredQuickLink(filtered);
  };

  const handleHelpAccord = (event, isExpanded) => {
    setSearchHarizon((prev) => ({
      ...prev,
      helpAccord: isExpanded,
    }));
  };

  const handleQuickViewTabChange = (event, newValue) => {
    setQuickViewValue(newValue);
  };

  const handleActivityChange = () => {
    setChatBotData((prev) => ({
      ...prev,
      details: prev.details === "See Details" ? "Hide Details" : "See Details",
    }));
  };

  const handleBannerClose = () => {
    setBanner(false);
  };

  return (
    <Grid2
      container
      ref={ref}
      spacing={3}
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      overflow={"hidden"}
      borderRadius={"10px"}
      backgroundColor="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <CommonGrid2
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        width={"100%"}
        container
        spacing={2}
      >
        <CommonGrid2 item size={12}>
          {isLoading ? (
            <HandleSkeletion height={80} width={"250px"} />
          ) : (
            <Typography variant="body6">
              {data.greeting}{" "}
              <CustomizeSpan color="#6941C6" textTransform="capitalize">
                {data.quickLink?.full_name}
              </CustomizeSpan>
            </Typography>
          )}
        </CommonGrid2>
      </CommonGrid2>
      {banner && (
        <Fragment>
          {isLoading ? (
            <HandleSkeletion height={80} width={"300px"} />
          ) : (
            data.notification && (
              <CommonGrid2
                background="#6941C6"
                borderRadius={"10px"}
                width={"100%"}
                display={"flex"}
                flexWrap={"nowrap"}
                alignItems={"center"}
                gap={"1rem"}
                justifyContent={"space-between"}
                padding={"0px 10px 0px 0px"}
              >
                <CommonGrid2
                  display="flex"
                  alignItems={"center"}
                  padding={"1rem"}
                  gap={"1rem"}
                >
                  <BannerIco />
                  <Typography variant="body4" color="#FFFFFF">
                    {data.notification}
                  </Typography>
                </CommonGrid2>
                <IconButton onClick={handleBannerClose}>
                  <XCloseIco stroke={"#FFFFFF"} />
                </IconButton>
              </CommonGrid2>
            )
          )}
        </Fragment>
      )}

      <QuickLink
        filteredQuickLink={filteredQuickLink}
        handleQuickLinkNavigate={handleQuickLinkNavigate}
        handleSearchQuickLink={handleSearchQuickLink}
        searchHarizon={searchHarizon}
        helpFiltered={helpFiltered}
        handleHelpAccord={handleHelpAccord}
        isLoading={isLoading}
        checkWidth={bounds.width}
      />
      <CustomDiv display="none">
        <QuickView
          quickViewValue={quickViewValue}
          handleQuickViewTabChange={handleQuickViewTabChange}
          isLoading={isLoading}
          handleActivityChange={handleActivityChange}
          chatBotData={chatBotData}
          setChatBotData={setChatBotData}
          gridRef={gridRef}
        />
      </CustomDiv>

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </Grid2>
  );
};
export default Dashboard;
